import {
  getStepNumberForIndicator,
  getTotalStepsForIndicator
} from '@common/hooks/multiStep';
import { StepIndicatorInfo, StepPathInfo } from '@common/hooks/multiStep/types';
import { RepostJobStepIds } from './stepConfig';

const stepsIndicatorInfo: StepIndicatorInfo<RepostJobStepIds> = {
  enhanceJob: {
    title: 'enhanceJobStep.stepTitle',
    pageTitle: 'enhanceJobStep.heading'
  },
  payment: {
    title: '',
    pageTitle: 'paymentJobStep.payWithCardHeading',
    ignoreIndicator: true
  },
  jobSummaryAndDesc: {
    title: 'summaryAndDescStep.stepTitle',
    pageTitle: 'summaryAndDescStep.heading'
  },
  postJobSuccess: {
    title: '',
    pageTitle: '',
    ignoreIndicator: true
  },
  repostTitle: {
    title: 'postJobTitleStep.stepTitle',
    pageTitle: 'postJobTitleStep.heading'
  },
  repostBasicDetails: {
    title: 'postJobBasicDetailsStep.stepTitle',
    pageTitle: 'postJobBasicDetailsStep.heading'
  },
  editTitle: {
    title: 'postJobTitleStep.stepTitle',
    pageTitle: 'postJobBasicDetailsStep.heading'
  },
  editBasicDetails: {
    title: 'postJobBasicDetailsStep.stepTitle',
    pageTitle: 'postJobBasicDetailsStep.heading'
  }
};

export const getPageTitle = (stepId: RepostJobStepIds) =>
  stepsIndicatorInfo[stepId].pageTitle;

export const getStepTitle = (stepId: RepostJobStepIds) =>
  stepsIndicatorInfo[stepId].title;

export const ignoreIndicator = (stepId: RepostJobStepIds) =>
  Boolean(stepsIndicatorInfo[stepId].ignoreIndicator);

export const totalNumberOfSteps = (steps: StepPathInfo<RepostJobStepIds>[]) =>
  getTotalStepsForIndicator<RepostJobStepIds>(steps, stepsIndicatorInfo);

export const getStepNumber = (
  steps: StepPathInfo<RepostJobStepIds>[],
  currentPathname: string
) => getStepNumberForIndicator(steps, stepsIndicatorInfo, currentPathname);
